import React from 'react';
import PropTypes from 'prop-types';
import ParkingPeriod from 'components/parking-passes/info-section/parking-period';
import EventInfo from 'components/parking-passes/info-section/event-info';
import LocationInfo from 'components/parking-passes/info-section/location-info';
import StubhubDisclaimer from 'components/parking-passes/info-section/stubhub-disclaimer';
import ExtendPassButton from 'components/parking-passes/info-section/extend-pass-button';

import { ParkingPass as ParkingPassModel } from 'models/parking-passes';
import BookingModel from 'models/booking';
import EventModel from 'models/event';
import VenueModel from 'models/venue';
import SellerModel from 'models/seller';
import { Location as LocationModel } from 'models/locations';

const InfoSection = ({ booking, parkingPass, location, seller, event, venue, locale, app, appContext, trackEvent }) => (
  <div className="info-section">
    <div className="container heavy-shadowed info-section-inner">
      <EventInfo parkingPass={parkingPass} event={event} venue={venue} />
      <ParkingPeriod booking={booking} parkingPass={parkingPass} locale={locale} />
      <ExtendPassButton
        app={app}
        appContext={appContext}
        booking={booking}
        location={location}
        trackEvent={trackEvent}
      />
    </div>
    <div className="container">
      <div className="row">
        <div className="col-xs-12 ticket-cutout" />
      </div>
    </div>
    <div className="container heavy-shadowed info-section-inner">
      <LocationInfo location={location} seller={seller} />
      <StubhubDisclaimer parkingPass={parkingPass} booking={booking} />
    </div>
  </div>
);

InfoSection.propTypes = {
  booking: PropTypes.instanceOf(BookingModel).isRequired,
  parkingPass: PropTypes.instanceOf(ParkingPassModel).isRequired,
  location: PropTypes.instanceOf(LocationModel).isRequired,
  seller: PropTypes.instanceOf(SellerModel).isRequired,
  event: PropTypes.instanceOf(EventModel),
  venue: PropTypes.instanceOf(VenueModel),
  locale: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
  appContext: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

InfoSection.defaultProps = {
  event: null,
  venue: null,
};

export default InfoSection;
